import React from 'react'
import * as styles from './filmsCards.module.scss'
import ComponentMedia from '../ComponentMedia/componentMedia'
const FilmsCards = ({gridItems}) => {
    const {cards} = gridItems
  return (
    <div className='container container-lg'>
        <div className={styles.cardContainer}>
            {cards.map((item:any, id:number) =>{
                const{title, youTubeUrl} = item
                return(
                    <div className={styles.cardWrapper}>
                        <div className={styles.card}>
                            <div>
                                <ComponentMedia data = {{youTubeUrl}} />
                            </div>
                            <div className={styles.title}>
                                <p>{title}</p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    </div>
  )
}

export default FilmsCards